/**
 * Globalna inwalidacja cache po eventach `data.changed` z WebSocketu (PLAN §9).
 *
 * Wcześniej robił to wyłącznie `useChat`, więc zmiany wprowadzone przez agenta
 * albo ceremonię odświeżały listy tylko wtedy, gdy akurat był otwarty czat.
 * Hook siedzi w `Layout`, czyli chodzi na każdym ekranie po zalogowaniu.
 */

import { useEffect } from "react";
import { useQueryClient, type QueryClient } from "@tanstack/react-query";
import { keys } from "../lists/hooks";
import { reviewKeys } from "../review/hooks";
import { wsClient } from "../ws";

/** Encja z eventu -> klucze TanStack Query do unieważnienia. */
export function invalidateEntity(qc: QueryClient, entity: string): void {
  const keysFor: Record<string, unknown[][]> = {
    stuff: [[...keys.inbox]],
    task: [["tasks"], ["projects"]],
    project: [["projects"], ["tasks"], ["horizons"]],
    horizon: [["horizons"], ["projects"]],
    checklist: [[...keys.checklists]],
    reference: [["references"]],
    memory: [["memory"]],
    review: [[...reviewKeys.current]],
    // calendar_add / undo z chatu zmienia kalendarz: widok agendy trzyma
    // klucze ["calendar-events", from, to, space], a ekran ustawień - status
    // połączenia i listę kalendarzy. Klucze działają prefiksowo.
    calendar: [["calendar-events"], ["calendar-status"]],
  };
  for (const key of keysFor[entity] ?? [["tasks"], ["projects"], [...keys.inbox]]) {
    void qc.invalidateQueries({ queryKey: key });
  }
}

export function useLiveData(): void {
  const qc = useQueryClient();

  useEffect(
    () =>
      wsClient.subscribe((event) => {
        if (event.type === "data.changed") invalidateEntity(qc, String(event.entity));
      }),
    [qc],
  );
}
